export default class MathUtil {
    public static degreesToRadians(degrees: number): number {
        return degrees * (Math.PI / 180);
    }
}
